import * as types from './types';

export const setActivePackage = ({ commit }, activePackage) => {
  commit(types.SET_ACTIVE, activePackage);
};

export const setLeaveIntention = ({ commit }, leaveIntention) => {
  commit(types.SET_LEAVE_INTENTION, leaveIntention);
};

export const setContactIntention = ({ commit }, payload) => {
  commit(types.SET_CONTACT_INTENTION, payload);
};

export const setStatus = ({ commit }, status) => {
  commit(types.SET_STATUS, status);
};

export const setScroll = ({ commit }, hasScroll) => {
  commit(types.SET_SCROLL, hasScroll);
};

export const setId = ({ commit }, id) => {
  commit(types.SET_ID, id);
};

export const setVersion = ({ commit }, version) => {
  commit(types.SET_VERSION, version);
};

export const setExternal = ({ commit }, payload) => {
  commit(types.SET_EXTERNAL, payload);
};

export const setPackage = ({ commit }, payload) => {
  commit(types.SET_PACKAGE, payload);
};

export const setPrePackage = ({ commit }, payload) => {
  commit(types.SET_PREPACKAGE, payload);
};

export const setTrackingPackage = ({ commit }, payload) => {
  commit(types.SET_TRACKING_PACKAGE, payload);
};

export const setAvailableNumbers = ({ commit }, payload) => {
  commit(types.SET_AVAILABLE_NUMBERS, payload);
};

export const setSettingsName = ({ commit }, payload) => {
  commit(types.SET_SETTINGS_NAME, payload);
};

export const setFrameVisibility = ({ commit }, payload) => {
  commit(types.SET_FRAME_VISIBILITY, payload);
};

export const setFrameUrl = ({ commit }, payload) => {
  commit(types.SET_FRAME_URL, payload);
};

export const setAuth = ({ commit }, payload) => {
  commit(types.SET_AUTH, payload);
};

export const setAuthToken = ({ commit }, payload) => {
  commit(types.SET_AUTH_TOKEN, payload);
};

export const setSalesGateway = ({ commit }, payload) => {
  commit(types.SET_SALES_GATEWAY, payload);
};

export const setMode = ({ commit }, payload) => {
  commit(types.SET_MODE, payload);
};

export const setReferral = ({ commit }, payload) => {
  if (typeof payload === 'number' && payload.toString().length === 8) {
    commit(types.SET_REFERRAL, payload);
  }
};

export const setEditable = ({ commit }, payload) => {
  commit(types.SET_EDITABLE, payload);
};

export const setAsBundle = ({ commit }, payload = true) => {
  commit(types.SET_AS_BUNDLE, payload);
};
export const setPortableInfo = ({ commit }, payload) => {
  commit(types.SET_PORTABLE_INFO, payload);
};

export default {
  setActivePackage,
  setLeaveIntention,
  setContactIntention,
  setScroll,
  setStatus,
  setId,
  setVersion,
  setExternal,
  setPackage,
  setPrePackage,
  setTrackingPackage,
  setAvailableNumbers,
  setSettingsName,
  setFrameVisibility,
  setFrameUrl,
  setAuth,
  setAuthToken,
  setSalesGateway,
  setMode,
  setReferral,
  setEditable,
  setAsBundle,
  setPortableInfo
};



// WEBPACK FOOTER //
// ./src/store/modules/simulation/actions.js